import React, { useState, useMemo } from 'react'
import './batch-price.scss'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { Row, Column } from '@/components/layout/layout'
import { createUseStyles } from 'react-jss'
import classnames from 'classnames'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage } from '@/utils/layer'
import Button from '@/components/button/button'
import { errorCallBack, INPUT_PRICE_LIMIT_REGEXP, isExist, WithInputLimit } from '@/utils'
import { isNoMore, WithScrollLoad } from '@/utils/utils-widget'
import { $post } from '@/api'
import { Goods } from '@/model/types/goods'
import { IPagination } from '@/model/types/common'
import { GoodsTableList } from '../goods-table'
import { useRequest, useDebounceFn, useUpdateEffect } from 'ahooks'
import { priceMethodType } from '../../edit-goods/modules/form/sale-price/sale-price'
import { intervalPriceMethod } from '@/utils/goods'
import { Spin } from 'antd'
import Big from 'big.js'
import $msg from '@/utils/message'
import { goodsLibraryStore } from '../../../store/goods-library'
import PopverConfirm2 from '@/components/popover-confirm/popver-confirm-2'

const useStyle = createUseStyles({
    action: {
        width: '62px',
        height: '32px',
        borderRadius: '5px',
        background: '#f2f2f2',
    },

    add: {
        width: '28px',
        height: '28px',
        color: '#999',
        fontSize: '12px',
        borderRadius: '5px',
        fontWeight: 600,
        cursor: 'pointer',
    },

    addActive: {
        color: '#14CC9B',
        background: '#fff',
        boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.10)',
    },

    reduceActive: {
        background: '#fff',
        boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.10)',
        color: '#E02020',
    },
})

interface BatchGoodPriceProps {
    goods_list: number[]
    goods_group_ids?: number[]
    goods_secondary_group_ids?: number[]
    goodIds: number[]
}

const BatchGoodPrice: React.FC<BatchGoodPriceProps> = props => {
    const styles = useStyle()
    const [type, setType] = useState<number>(1) // 1 add 2 reduce
    const [amount, setAmount] = useState<string>('')
    const [val, setVal] = useState<number>(0)

    const { run: debonceRun } = useDebounceFn(
        (e: number) => {
            setVal(e)
        },
        {
            wait: 500,
        },
    )

    useUpdateEffect(() => {
        debonceRun(+amount)
    }, [amount])

    const cls = useBemClass('batch-price')

    const requestHandle = useRequest<
        GoodsTableList,
        {
            goods_list: Goods[]
            pagination: IPagination
        }
    >(
        val =>
            $post({
                url: '/goods/getgoods',
                params: {
                    limit: 20,
                    goods_ids: props.goodIds,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                },
            }),
        {
            isNoMore: isNoMore,
            onError: errorCallBack,
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.goods_list,
                    pagination: data.pagination,
                }
            },
        },
    )

    const batchReq = useRequest(
        () =>
            $post({
                url: '/goods/onekeyeditgoodspricingmethod',
                params: {
                    ...props,
                    goodIds: void 0,
                    change_pirce: finalVal,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                layerManage.pop()
                $msg('success', '处理成功')
                goodsLibraryStore.setUpdateGroupStatus()
            },
            onError: errorCallBack,
        },
    )

    const finalVal = useMemo(() => {
        return type === 1 ? val : 0 - val
    }, [type, val])

    return (
        <BaseDialog isShow title="批量统一改价" onClose={() => layerManage.pop()}>
            <Column data-width-100p data-padding-h-20>
                <Row data-aling-items-center data-justify-content-space-between>
                    <Column>
                        <div data-font-size-14 data-color-000 data-font-weight-600>
                            统一改价设置
                        </div>
                        <div data-margin-top-8 data-color-999 data-font-size-12>
                            可对所有商品售价/会员价加减固定金额
                        </div>
                    </Column>
                    <Row data-align-items-center>
                        <div data-center className={styles.action}>
                            <div
                                data-center
                                className={classnames(styles.add, {
                                    [`${styles.addActive}`]: type === 1,
                                })}
                                onClick={() => {
                                    setType(1)
                                }}
                            >
                                加
                            </div>
                            <div
                                onClick={() => {
                                    setType(2)
                                }}
                                data-center
                                className={classnames(styles.add, {
                                    [`${styles.reduceActive}`]: type === 2,
                                })}
                            >
                                减
                            </div>
                        </div>
                        <div data-position-relative>
                            <div className={cls('ipt', 'des')}>{type === 1 ? '+' : '-'}¥</div>
                            {WithInputLimit(
                                <input
                                    className={cls('ipt')}
                                    value={amount}
                                    placeholder="请输入金额"
                                    onChange={e => {
                                        setAmount(e.target.value)
                                    }}
                                />,
                                INPUT_PRICE_LIMIT_REGEXP,
                            )}
                        </div>
                    </Row>
                </Row>
                <Column data-margin-top-17 className={cls('table')}>
                    <Row>
                        <div className={classnames(cls('top'), cls('top', '0'))}>类型</div>
                        <div className={classnames(cls('top'), cls('top', '1'))}>计价单位</div>
                        <div className={classnames(cls('top'), cls('top', '2'))}>售价</div>
                        <div className={classnames(cls('top'), cls('top', '3'))}>会员价</div>
                    </Row>
                    <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                        <Spin spinning={requestHandle.loading || requestHandle.loadingMore}>
                            <Column className={cls('content')}>
                                {requestHandle.data?.list.map((good, index) => (
                                    <Column key={good.id}>
                                        <Row
                                            data-padding-h-8
                                            data-color-999
                                            data-font-size-12
                                            data-align-items-center
                                            data-height-30
                                            data-justify-content-space-between
                                            className={cls('top-line')}
                                        >
                                            <Row>
                                                #{index + 1}
                                                {isExist(good.goods_package) && (
                                                    <div className={cls('package')}>套</div>
                                                )}
                                                <span data-margin-left-4 className={cls('content', 'title')}>
                                                    {good.name}
                                                </span>
                                            </Row>
                                            <div>
                                                {good.group.name}
                                                {isExist(good.secondary_group) && (
                                                    <span>/{good.secondary_group.name}</span>
                                                )}
                                            </div>
                                        </Row>
                                        {good.pricing_methods.map(price => (
                                            <Row key={price.id}>
                                                <div className={classnames(cls('line'), cls('line', '0'))}>
                                                    <div
                                                        className={classnames(
                                                            cls('price-type'),
                                                            cls(`price-type`, priceMethodType[price.method_type].style),
                                                        )}
                                                    >
                                                        {priceMethodType[price.method_type].txt}
                                                    </div>
                                                </div>
                                                <div className={classnames(cls('line'), cls('line', '1'))}>
                                                    元/{price.sales_unit.name}
                                                </div>
                                                <div className={classnames(cls('line'), cls('line', '2'))}>
                                                    {!!val && (
                                                        <div
                                                            style={{
                                                                color:
                                                                    +Big(
                                                                        price.sale_prices.length > 1
                                                                            ? intervalPriceMethod(price).min
                                                                            : +price.sale_prices[0].sale_price,
                                                                    ).plus(finalVal) <= 0
                                                                        ? '#ff4343'
                                                                        : '',
                                                            }}
                                                        >
                                                            {price.sale_prices.length > 1 ? (
                                                                <div>
                                                                    ¥
                                                                    {
                                                                        +Big(intervalPriceMethod(price).min).plus(
                                                                            finalVal,
                                                                        )
                                                                    }
                                                                    ~
                                                                    {
                                                                        +Big(intervalPriceMethod(price).max).plus(
                                                                            finalVal,
                                                                        )
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    ¥
                                                                    {
                                                                        +Big(+price.sale_prices[0].sale_price).plus(
                                                                            finalVal,
                                                                        )
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div>
                                                        {price.sale_prices.length > 1 ? (
                                                            <div
                                                                className={classnames({
                                                                    [cls('line', 'del')]: val,
                                                                })}
                                                            >
                                                                ¥{intervalPriceMethod(price).min}~
                                                                {intervalPriceMethod(price).max}
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className={classnames({
                                                                    [cls('line', 'del')]: val,
                                                                })}
                                                            >
                                                                ¥{price.sale_prices[0].sale_price}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className={classnames(cls('line'), cls('line', '3'))}>
                                                    {isExist(price.member_price) && !!val && (
                                                        <div
                                                            style={{
                                                                color:
                                                                    +Big(+price.member_price.sale_price).plus(
                                                                        finalVal,
                                                                    ) <= 0
                                                                        ? '#ff4343'
                                                                        : '',
                                                            }}
                                                        >{`¥${+Big(+price.member_price.sale_price).plus(
                                                            finalVal,
                                                        )}`}</div>
                                                    )}
                                                    <div
                                                        className={classnames({
                                                            [cls('line', 'del')]: val,
                                                        })}
                                                    >
                                                        {isExist(price.member_price)
                                                            ? `¥${price.member_price.sale_price}`
                                                            : '-'}
                                                    </div>
                                                </div>
                                            </Row>
                                        ))}
                                    </Column>
                                ))}
                            </Column>
                        </Spin>
                    </WithScrollLoad>
                </Column>

                <Row data-justify-content-flex-end data-margin-v-20>
                    <PopverConfirm2
                        trigger="click"
                        types="error"
                        placement="topRight"
                        onConfirm={batchReq.run}
                        content={
                            <div data-color-000 data-font-size-14>
                                确认统一
                                <span data-font-weight-600 data-margin-h-6>
                                    {type === 1 ? '加' : '减'}
                                    {Math.abs(finalVal)}元
                                </span>
                                吗？
                            </div>
                        }
                    >
                        <Button disabled={!parseFloat(amount)} types="default" loading={batchReq.loading}>
                            确认改价
                        </Button>
                    </PopverConfirm2>
                </Row>
            </Column>
        </BaseDialog>
    )
}

export default BatchGoodPrice
